import { css } from 'styled-components';
import { colors, elevation } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import * as zIndex from './z-index';

/**
 * Cards
 */
export const e100 = css`
    ${elevation.e100};
    z-index: ${zIndex.card};
`;

/**
 * Inline dialogs
 */
export const e200 = css`
    ${elevation.e200};
    z-index: ${zIndex.dialog};
`;

/**
 * Modals
 */
export const e300 = css`
    ${elevation.e300};
    z-index: ${zIndex.modal};
`;

/**
 * (Side)Panels
 */
export const e400 = css`
    ${elevation.e400};
    z-index: ${zIndex.panel};
`;

/**
 * Flag messages
 */
export const e500 = css`
    ${elevation.e500};
    z-index: ${zIndex.flag};
`;

export const newElevationsFromDesignSystems = {
    e100: css`
        z-index: ${zIndex.card};
        box-shadow: ${token('elevation.shadow.raised', `0 1px 1px ${colors.N50A}, 0 0 1px 1px ${colors.N40A}`)};
    `,
    e200: css`
        z-index: ${zIndex.dialog};
        box-shadow: ${token('elevation.shadow.overlay', `0 4px 8px -2px ${colors.N50A}, 0 0 1px ${colors.N60A}`)};
    `,
};
